module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/2mill-active-3cd5190f92f2fa658b1a8b9a5b68a918.png";